import axiosPrivate from './axiosPrivate';

const catalogo = () => {
  return axiosPrivate.get('validacion-servicio/catalogo').then((r) => r.data);
};

const usuariosOpciones = () => {
  return axiosPrivate.get('validacion-servicio/usuarios-opciones').then((r) => r.data);
};

const listar = (params = {}) => {
  return axiosPrivate.get('validacion-servicio', { params }).then((r) => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('validacion-servicio', payload).then((r) => r.data);
};

const actualizar = (payload) => {
  return axiosPrivate.put('validacion-servicio', payload).then((r) => r.data);
};

const subirPlanilla = (id, archivo, usuario_id) => {
  const fd = new FormData();
  fd.append('id', id);
  fd.append('archivo_planilla_validacion_servicio', archivo);
  fd.append('usuario_id', usuario_id);
  return axiosPrivate.post('guardarPlanillaValidacionServicio', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export default {
  catalogo,
  usuariosOpciones,
  listar,
  crear,
  actualizar,
  subirPlanilla,
};
